import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['quoteContainer'];
  static values = {
    selected: String,
    type: String
  };

  hide(elementId) {
    document.querySelector(elementId).classList.add('d-none');
  }

  show(elementId) {
    document.querySelector(elementId).classList.remove('d-none');
  }

  selectedValueChanged() {
    const selectedQuoteElement = document.querySelector('#selected_quote_id');

    if (!selectedQuoteElement) {
      return;
    }

    selectedQuoteElement.value = this.selectedValue;

    document.querySelectorAll('.quote-container').forEach((element) => {
      element.classList.remove('selected');

      if (element.dataset.id === this.selectedValue) {
        const needConsent = parseInt(element.dataset.commission) > 0 && this.typeValue != 'vacant_cover';
        const isScheme = element.dataset.scheme === 'true';

        document.querySelector('#scheme-submit-quote-btn').disabled = false;

        if (isScheme && needConsent) {
          this.show('#scheme-open-consent-btn')
          this.hide('#scheme-submit-quote-btn')
          this.hide('#select-quote-with-confirmation')
          this.hide('#non-scheme-open-consent-btn')
          this.hide('#non-scheme-submit-quote-btn')
        } else if (isScheme && !needConsent) {
          this.hide('#scheme-open-consent-btn')
          this.show('#scheme-submit-quote-btn')
          this.hide('#select-quote-with-confirmation')
          this.hide('#non-scheme-open-consent-btn')
          this.hide('#non-scheme-submit-quote-btn')
        } else if (!isScheme && needConsent) {
          this.hide('#scheme-open-consent-btn')
          this.hide('#scheme-submit-quote-btn')
          this.show('#select-quote-with-confirmation')
          this.show('#non-scheme-open-consent-btn')
          this.hide('#non-scheme-submit-quote-btn')
        } else if (!isScheme && !needConsent) {
          this.hide('#scheme-open-consent-btn')
          this.hide('#scheme-submit-quote-btn')
          this.show('#select-quote-with-confirmation')
          this.hide('#non-scheme-open-consent-btn')
          this.show('#non-scheme-submit-quote-btn')
        }

        element.classList.add('selected');
      }
    });
  }

  clickQuote(event) {
    const quoteId = event.currentTarget.dataset.id;
    this.element.querySelector(`#quote_id_${quoteId}`).checked = true;
    this.selectedValue = quoteId;
  }

  updateSelected(event) {
    this.selectedValue = event.target.value;
  }
}
